import { Routes } from '@angular/router';
import { Ng1LoadedGuard } from '../shared/ng1/ng1-loaded.guard';
import { FirstStepsRootComponent } from './first-steps-root/first-steps-root.component';
import { FirstStepsWebCallComponent } from './first-steps-web-call/first-steps-web-call.component';
import { FirstStepsWebCallInstallationComponent } from './first-steps-web-call-instsallation/first-steps-web-call-installation.component';
import { FirstStepsNumbersComponent } from './first-steps-numbers/first-steps-numbers.component';
import { FirstStepsLeadGenerationResolve } from './first-steps.lead-generation.resolve';

export const firstStepsRoutes: Routes = [
  {
    path: 'first-steps',
    canActivate: [Ng1LoadedGuard],
    component: FirstStepsRootComponent,
    children: [
      {
        path: 'web-call-init',
        component: FirstStepsWebCallComponent,
        resolve: {
          leadGeneration: FirstStepsLeadGenerationResolve
        }
      },
      {
        path: 'web-call-installation',
        component: FirstStepsWebCallInstallationComponent,
        resolve: {
          leadGeneration: FirstStepsLeadGenerationResolve
        }
      },
      {
        path: 'numbers',
        component: FirstStepsNumbersComponent
      }
    ]
  }
];
